module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai292-ec26741a6871a52cb55e537c80452da9.jpg";